import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { getPendingReports, markReportSynced, removeSyncedReports } from '@/stores/offlineStore';
import { addCommunityReport } from '@/stores/reportsStore';
import { persistVisibilityReport } from '@/lib/persistVisibilityReport';
import { toast } from 'sonner';

/** Invisible component that syncs pending offline reports when back online */
const OfflineSync = () => {
  const online = useOnlineStatus();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!online) return;
    const pending = getPendingReports();
    if (pending.length === 0) return;

    (async () => {
      for (const report of pending) {
        addCommunityReport({
          siteId: report.siteId,
          diverName: report.diverName,
          visibility: report.visibility,
          depthBands: report.depthBands,
          comment: report.comment,
          surfaceCondition: report.surfaceCondition,
        });

        // Persist to DB with surface_condition
        await persistVisibilityReport({
          siteId: report.siteId,
          visibility: report.visibility,
          depthBands: report.depthBands,
          diveDate: report.createdAt.slice(0, 10),
          comment: report.comment,
          surfaceCondition: report.surfaceCondition,
        });

        markReportSynced(report.localId);
      }

      removeSyncedReports();
      queryClient.invalidateQueries({ queryKey: ['community-dive-sites'] });
      queryClient.invalidateQueries({ queryKey: ['visibility-logs'] });
      queryClient.invalidateQueries({ queryKey: ['all-visibility-logs'] });
      toast.success(`${pending.length} Meldung${pending.length > 1 ? 'en' : ''} synchronisiert`);
    })();
  }, [online, queryClient]);

  return null;
};

export default OfflineSync;
